export default (props, vars) =>
  props?.['students'].findIndex(
    (s) => s.id === vars?.['usestateprofilepopupopened']?.['state']
  ) === 0
    ? 'hidden'
    : undefined;
